export const UPGRADE_CONFIG_CACHE_KEY = 'HS_UPGRADE_CONFIG_CACHE';
export const writeUpgradeConfigToLocalStorage = config => {
  try {
    localStorage.setItem(UPGRADE_CONFIG_CACHE_KEY, JSON.stringify({
      timestamp: Date.now(),
      upgradeConfig: config
    }));
  } catch (_unused) {
    // localStorage may be full or unavailable; silently fall back
  }
};